import { render, staticRenderFns } from "./GruChart.vue?vue&type=template&id=bb3e3908&"
import script from "./GruChart.vue?vue&type=script&lang=js&"
export * from "./GruChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports